import { EventTrackingProps, ToastType } from "@/types/common";
import { createContext, useContext } from "react";

const defaultTranslation: any = {};
export const ProfileContext = createContext({
  translation: defaultTranslation,
  isMobile: false,
  showToast: (val: ToastType) => {},
  handleEventTracking: (event: EventTrackingProps) => {},
  hostname: "",
});

export function useProfile() {
  return useContext(ProfileContext);
}
